import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  heading: {
    marginBottom: 30,
  },
  text: {
    fontSize: 18,
    lineHeight: '28px',
    color: '#080808',
    marginBottom: 40,
  },
  rightColumn: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end'
    }
  },
  image: {
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
    height: 'auto',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 520,
      height: 661,
    }
  },
}));
